import * as React from 'react';
import DataMatcherHeaderPopover from './HeaderPopover';
import './DataMatcherHeader.less';
import { useTranslation } from 'react-i18next';
import { ConnectAuth } from 'models/AuthModel';

export interface DataMatcherHeaderProps {
  connectAuth: ConnectAuth | undefined;
  handleShowModal: () => void;
}

const DataMatcherHeader = (props: DataMatcherHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div id="data-matcher-header" className={'w-100% p-24 pb-0 pt-16 flex items-center'}>
      <div className="w-100% flex text-20 data-matcher-header" data-cy="SidebarHeader">
        {t('Data Matching')}
        <DataMatcherHeaderPopover connectAuth={props.connectAuth} />
      </div>
    </div>
  );
};

export default DataMatcherHeader;
